import { render, staticRenderFns } from "./NewProBanner.vue?vue&type=template&id=48c643d6&scoped=true&"
import script from "./NewProBanner.vue?vue&type=script&lang=ts&"
export * from "./NewProBanner.vue?vue&type=script&lang=ts&"
import style0 from "./NewProBanner.vue?vue&type=style&index=0&id=48c643d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c643d6",
  null
  
)

export default component.exports